export default "__VITE_ASSET__BXHSAfiF__"